class GallerySliderPlugin {
  static options = {
    wrapperElement: '[data-custom-slider]',
    sliderContainer: '[data-slider-container]',
    slide: '[data-slide]',
    thumbnailsContainer: '[data-slider-thumbnails]',
    thumbnail: '[data-thumbnail]',
    scrollPaddingTop: 100,
    scrollPaddingLeft: 20,
    breakpoint: 1024,
  };

  constructor(Wrapper) {
    this._Wrapper = Wrapper;
    if (!this._Wrapper) return;
    this._sliderContainer = this._Wrapper.querySelector(GallerySliderPlugin.options.sliderContainer);
    this._slides = this._Wrapper.querySelectorAll(GallerySliderPlugin.options.slide);
    this._thumbnailsContainer = this._Wrapper.querySelector(GallerySliderPlugin.options.thumbnailsContainer);
    this._thumbnails = this._Wrapper.querySelectorAll(GallerySliderPlugin.options.thumbnail);
    // Classes are set in TWIG on the [data-active-thumbnail-classes] attribute
    this._activeThumbnailClasses = this._thumbnailsContainer.dataset.activeThumbnailClasses.split(' ');

    // All data corresponding to the above selected items
    this._slideData = this._calculateSlides();
    this._thumbnailData = this._calculateThumbnails();

    // Check breakpoint for mobile or desktop
    this._isMobile = window.innerWidth < GallerySliderPlugin.options.breakpoint;

    // console.log('GallerySliderPlugin initialized with:', {
    //   Wrapper: this._Wrapper,
    //   sliderContainer: this._sliderContainer,
    //   slides: this._slides,
    //   thumbnailsContainer: this._thumbnailsContainer,
    //   thumbnails: this._thumbnails,
    //   activeThumbnailClasses: this._activeThumbnailClasses,
    //   slideData: this._slideData,
    //   thumbnailData: this._thumbnailData,
    //   isMobile: this._isMobile,
    //   breakpoint: GallerySliderPlugin.options.breakpoint,
    //   width: window.innerWidth,
    // });

    this._registerEventListeners();
  }

  _registerEventListeners() {
    this._thumbnails.forEach((_thumbnail) => {
      _thumbnail.addEventListener('click', () => {
        this._handleThumbnailClick(event.target);
        // console.log('Thumbnail clicked:', event.target.dataset.thumbnail);
      });
    });
    this._sliderContainer.addEventListener('scroll', () => {
      this._trackScrollPosition();
      // console.log('Slider scrolled, tracking position...');
    });
  }

  _trackScrollPosition() {
    this._slideData.forEach((slide) => {
      /**
       * If we are below the breakpoint, check for vertical scroll and values
       * If we are above the breakpoint, check for horizontal scroll and values
       */
      let isIntersecting;
      if (this._isMobile) {
        /**
         * Scroll position should be greater than the slide position MINUS a padding left. This way the next slide will be 'activated' about 20px before it hits the left side of the scroll div.
         * Scroll position should be less than the slide position + its width. Meaning it will only trigger as long as the slide is in the viewport.
         */
        const scrollLeft = this._sliderContainer.scrollLeft;
        isIntersecting = scrollLeft > slide.item.offsetLeft - GallerySliderPlugin.options.scrollPaddingLeft && scrollLeft < slide.item.offsetLeft + slide.width;
      } else {
        /**
         * Scroll position should be greater than the slide position MINUS a padding top. This way the next slide will be 'activated' about 100px before it hits the top of the scroll div.
         * Scroll position should be less than the slide position + its height. Meaning it will only trigger as long as the slide is in the viewport.
         */
        const scrollTop = this._sliderContainer.scrollTop;
        isIntersecting = scrollTop > slide.item.offsetTop - GallerySliderPlugin.options.scrollPaddingTop && scrollTop < slide.item.offsetTop + slide.height;
      }

      if (isIntersecting) {
        const intersecting = this._thumbnailData.find((thumb) => thumb.index === slide.index);

        const notIntersecting = this._thumbnailData.filter((thumbnail) => {
          return thumbnail.index !== intersecting.index;
        });

        notIntersecting.forEach((thumbnailObj) => {
          thumbnailObj.item.classList.remove(...this._activeThumbnailClasses);
          thumbnailObj.item.closest('.thumbnail-item').classList.remove('active');
        });
        intersecting.item.classList.add(...this._activeThumbnailClasses);

        intersecting.item.closest('.thumbnail-item').classList.add('active');
      }
    });
  }

  _handleThumbnailClick(clickedThumbnail) {
    const id = clickedThumbnail.dataset.thumbnail;
    const item = this._Wrapper.querySelector(`[data-slide="${id}"]`);
    // console.log('Clicked thumbnail:', id);
    // check for breakpoint and scroll to the correct position
    if (this._isMobile) {
      this._sliderContainer.scrollTo({
        left: item.offsetLeft - 16,
        behavior: 'smooth',
      });
      // console.log('Scrolling to:', item.offsetLeft - 16);
    } else {
      this._sliderContainer.scrollTo({
        top: item.offsetTop,
        behavior: 'smooth',
      });

      // console.log('Scrolling to:', item.offsetTop);
    }
  }

  _calculateSlides() {
    const slidesArray = [];
    this._slides.forEach((item, index) => {
      slidesArray.push({
        index: index,
        height: item.offsetHeight,
        width: item.offsetWidth,
        item: item,
      });
    });
    // console.log('Slides calculated:', slidesArray);
    return slidesArray;
  }

  _calculateThumbnails() {
    const thumbnailArray = [];
    this._thumbnails.forEach((item, index) => {
      thumbnailArray.push({
        index: index,
        item: item,
      });
    });
    // console.log('Thumbnails calculated:', thumbnailArray);
    return thumbnailArray;
  }

  static initAll() {
    const Wrapper = document.querySelectorAll(GallerySliderPlugin.options.wrapperElement);
    // console.log('Initializing all sliders:', Wrapper);
    if (Wrapper) {
      Wrapper.forEach((sliderContainer) => {
        new GallerySliderPlugin(sliderContainer);
      });
    }
  }
}

GallerySliderPlugin.initAll();

// Beschikbaar voor src/product-configurator.js, die de galerij na het wisselen opnieuw initialiseert.
window.GallerySliderPlugin = GallerySliderPlugin;

/**
 * CUSTOM FOR THE TRANSLATED PAGES OF NOVALINE
 * We are using captions that are filled from the ALT text of the image on the product pages
 */
(function () {
  function fillCaptions(root = document) {
    const slides = root.querySelectorAll('.custom-slider .main-slide');

    slides.forEach((slide) => {
      const img = slide.querySelector('img[alt]');
      if (!img) return;

      const alt = (img.getAttribute('alt') || '').trim();
      if (!alt) return;

      // Split op de eerste '|'
      const parts = alt.split('|');
      const before = (parts[0] || alt).trim();
      const after = (parts[1] || '').trim();

      // Ondersteun zowel [caption-before-split] als [data-caption-before-split]
      const beforeEl = slide.querySelector('.caption [caption-before-split]') || slide.querySelector('.caption [data-caption-before-split]');

      const afterEl = slide.querySelector('.caption [caption-after-split]') || slide.querySelector('.caption [data-caption-after-split]');

      if (beforeEl) beforeEl.textContent = before;
      if (afterEl) afterEl.textContent = after;
    });
  }

  // Run zodra de DOM klaar is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fillCaptions());
  } else {
    fillCaptions();
  }
})();
